import { jsx as _jsx } from "react/jsx-runtime";
import { shorten } from "shared/misc";
import ThumbnailIcon from "../box/ThumbnailIcon.js";
import { fileIcon } from "../index.js";
import { useUrl } from "./index.js";
export default function VideoThumbnail(props) {
    const url = useUrl(props.file.url);
    if (props.play) {
        return (_jsx("video", { controls: true, className: "d-block w-100 h-100", style: { background: "black" }, onClick: () => void 0, children: _jsx("source", { src: url, type: props.file.type }) }));
    }
    else {
        return _jsx(ThumbnailIcon, { icon: fileIcon(props.file.type), children: shorten(props.file.name) });
    }
}
